'use client'

import React, { memo } from 'react'
import useBraintreeCreditCard from '@segway/core/src/businessHooks/useBraintreeCreditCard'
import { useDebounceFn, useUpdateEffect } from 'ahooks'

import { useRouter } from '@/i18n/navigation'
import { Button, Checkbox } from '@/ui'
import { generateGTMCartItemsParams } from '@/utils'
import reportGTMEvent from '@/utils/gtm'

/**
 * Braintree Credit Card 支付组件
 *
 * @param {string} [code] - 支付方式代码
 * @param {string} [googleReCaptchaToken] - 谷歌人机验证的token
 *
 */
const BraintreeCreditCard = ({
  code,
  googleReCaptchaToken,
  selectMethod,
}: {
  code: string
  googleReCaptchaToken: string
  selectMethod: (method: string) => void
}) => {
  const router = useRouter()
  const {
    isLoading,
    handlePlaceOrder,
    paymentELeVisible,
    initPaymentAgain,
    refreshRef,
    isSaveCreditCard,
    saveCreditCardChange,
    saveForLaterUseVisible,
    placeOrderBtnVisible,
    saveForLaterUseTitle,
    appliedCoupons,
  } = useBraintreeCreditCard(
    code,
    router,
    googleReCaptchaToken,
    reportGTMEvent,
    generateGTMCartItemsParams,
  )

  // fix: bad 当前使用的 braintree-web-drop-in 包 apple pay 无法支持快捷支付
  useUpdateEffect(() => {
    if (code) {
      selectMethod('')
    }
  }, [appliedCoupons])

  const { run: placeOrder } = useDebounceFn(
    () => {
      handlePlaceOrder()
    },
    {
      wait: 500,
    },
  )

  return (
    <div className="pb-3">
      {/* 控制重置支付组件 */}
      <div ref={refreshRef} onClick={initPaymentAgain} className="hidden" />

      {isLoading && <div className="py-5 text-center text-[#aaa]">Loading...</div>}
      {paymentELeVisible && <div id={code} />}

      {/* 保存（信用卡、Paypal）复选框 */}
      {saveForLaterUseVisible && (
        <div className="mb-3 flex items-center">
          <Checkbox checked={isSaveCreditCard} onCheckedChange={saveCreditCardChange} />
          <span className="ml-2 text-[12px] text-[#222223] xl:text-base">
            {saveForLaterUseTitle}
          </span>
        </div>
      )}

      {placeOrderBtnVisible && <Button onClick={placeOrder}>Place Order</Button>}
    </div>
  )
}

export default memo(BraintreeCreditCard)
